import * as React from "react";
import _ from 'lodash';
import { useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, makeStyles, Checkbox, withStyles, Button, Modal, Grid } from '@material-ui/core';
// eslint-disable-next-line no-unused-vars
import { Accessible, Pets, ChildFriendly, DirectionsBike, ChildCare, AccessibilityNew } from '@material-ui/icons';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { useDispatch, useSelector } from "react-redux";
import { updatePax } from "../../store/departures";
import { BagModal } from "./bagModal";
import { getEmailHistory } from "./utils/getEmailHistory";
import { TeddyBear } from "../../images/teddyBear"
import { Firearm } from "../../images/firearm";
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import { FlightTakeoff } from "@material-ui/icons";
import { reservationInfoReceived } from "../../store/departures";
import { getResInfo } from '../../utils/globalFunctions';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  }
}));

const StyledTableHead = withStyles(() => ({
  root: {
    display: 'table-header-group',
    fontSize: '0.875rem',
    borderBottom: '2px solid rgba(201, 195, 195, 1)',
    textAlign: 'left',
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: '0.01071em'
  }  
}))(TableRow);

const facts = [
  {code: 'WEAP', name: ['CHECKED FIREARMS'], icon: <Firearm />},
  {code: 'PETC', name: ['ANIMALS ON BOARD', 'GUEST PETS', 'CABIN PETS'], icon: <Pets />},
  {code: 'SVAN', name: ['SERVICE ANIMAL', 'PASSENGER WITH SERVICE ANIMAL IN CABIN'], icon: <AccessibilityNew />},
  {code: 'INFT', name: ['BABY ON BOARD', 'INFANT ON BOARD', 'INFANT', 'BABY'], icon: <ChildFriendly />},
  {code: 'WC', name: ['WHEELCHAIR'], icon: <Accessible />},
  {code: 'UMNR', name: ['MINOR TRAVELLING', 'MINOR TRAVELING', 'UNACCOMPANIED MINOR'], icon: <TeddyBear />},
  {code: 'SHTL', name: ['FREE SHUTTLE', 'LAX shuttle'], icon: <AirportShuttleIcon />},
  {code: 'BIKE', name: ['GUEST BICYCLES', 'BICYCLE'], icon: <DirectionsBike />}
];

function createData(type, name, rloc, phoneNumber, dob, bagWeight, paxWeight, emailHist, finalDest, resStatus, ssrs, travelStatus, key, jKey, paxAuthority, pjd, timestamp,isInterline) {
  return { type, name, rloc, phoneNumber, dob, bagWeight, paxWeight, emailHist, finalDest, resStatus, ssrs, travelStatus, key, jKey, timestamp, pjd, paxAuthority, isInterline };
}

const getTravelStatus = (travelStatus) => {
  if (travelStatus.checkedIn) {
    return 'checked in'
  }
  else if (travelStatus.notCheckedIn) {
    return 'not checked in'
  }
  else if (travelStatus.noshow) {
    return 'no show'
  }
  else {
    return 'boarded'
  }
}

// NOTE // configures rows (passengers) for display
const configureRows = (tailItem, emailHistory,reservationInfo) => {
  let rows = []

  const formatName = (nameArr) => {
    for (let i = 0; i < nameArr.length; i++) {
      let name = nameArr[i];
      name = name.toLowerCase()
      let nna = name.split('')
      nna[0] = nna[0].toUpperCase()
      nameArr[i] = nna.join('')
    }
    return nameArr.join(' ')
  }

// function hasASAirlineCode(segments) {
//   return segments.some(segment => 
//     segment.flight &&
//     segment.flight.airlineCode &&
//     segment.flight.airlineCode.code === "AS"
//   );
// }

function hasASAirlineCode(journeys) {
  if (!Array.isArray(journeys)) return false;

  return journeys.some(journey =>
    Array.isArray(journey.segments) &&
    journey.segments.some(segment =>
      segment.flight &&
      segment.flight.airlineCode &&
      segment.flight.airlineCode.code === "AS"
    )
  );
}


  // const checkInterline = (key, reservationData) => {
  //     if (!Array.isArray(reservationData) || reservationData.length === 0) {
  //     return false;
  //   }
  //   console.log(reservationData, "my reservation data", key, "my key", tailItem, "tail Item")
  //   const selectedData = reservationData.find(data => data.locator === key);
  //   console.log(selectedData,"my selected data")
  //   if (
  //     !selectedData ||
  //     !selectedData.journeys ||
  //     !Array.isArray(selectedData.journeys) ||
  //     selectedData.journeys.length === 0 ||
  //     !selectedData.journeys[0].segments
  //   ) {
  //     return false;
  //   }

  //   return hasASAirlineCode(selectedData.journeys[0].segments);
  // }

  const checkInterline = (key, reservationData) => {
  if (!Array.isArray(reservationData) || reservationData.length === 0) {
    return false;
  }

  const selectedData = reservationData.find(data => data.locator === key);

  if (
    !selectedData ||
    !Array.isArray(selectedData.journeys) ||
    selectedData.journeys.length === 0
  ) {
    return false;
  }

    return hasASAirlineCode(selectedData.journeys);
  };

  const getResStatus = (resStatus) => {
    if (resStatus.standby) {
      return 'STBY'
    }
    else if (resStatus.confirmed) {
      return 'CONF'
    }
    else{
      return ' '
    }
  }

  // NOTE // configures passenger data for display
  if (tailItem && tailItem.passengers) {
    for (let i = 0; i < tailItem.passengers.length; i++) {
      const pax = tailItem.passengers[i]
      const type = 'pax'
      const name = formatName([pax.profile.title, pax.profile.firstName, pax.profile.lastName])
      const isInterline = Array.isArray(reservationInfo) && reservationInfo.length > 0
  ? checkInterline(pax.reservation.locator, reservationInfo)
  : false;
      const rloc = pax.reservation.locator
      const phone = pax.reservation.bookingInformation.contactInformation.phoneNumber
      const dob = pax.profile.birthDate
      const travelStatus = getTravelStatus(pax.passengerJourneyDetail.travelStatus)
      const bagWeight = pax.passengerJourneyDetail.bags ? pax.passengerJourneyDetail.bags : ''
      const paxWeight = pax.passengerJourneyDetail.weight.amount || 0
      const emailHist = getEmailHistory(pax.reservation.locator, emailHistory)
      const finalDest = pax.passengerJourneyDetail.destinationAirport.code
      const resStatus = getResStatus(pax.passengerJourneyDetail.reservationStatus)
      const key = pax.key
      const jKey = pax.passengerJourneyDetail.key
      const paxAuthority = pax.passengerJourneyDetail.authorityClearance.result
      const pjd = pax.passengerJourneyDetail
      const timestamp = pax.passengerJourneyDetail.timestamp
      console.log("paxAuthority",paxAuthority);
      let paxSSRs = []
      // NOTE // looking for service requests with matching codes
      if (pax.passengerJourneyDetail.passengerServiceRequests) {
        for (let j = 0; j < pax.passengerJourneyDetail.passengerServiceRequests.length; j++) {
          let sr = pax.passengerJourneyDetail.passengerServiceRequests[j]
          let fact = facts.find((item) => sr.serviceRequest.code.startsWith(item.code))
          if (fact) {
            paxSSRs.push(fact.icon)
          }
        }
      }
      // NOTE // looking for purchases with matching names (e.g. 'CHECKED FIREARMS')
      if (pax.passengerJourneyDetail.ancillaryPurchases) {
        for (let j = 0; j < pax.passengerJourneyDetail.ancillaryPurchases.length; j++) {
          let ap = pax.passengerJourneyDetail.ancillaryPurchases[j];
          let fact = facts.find((item) => item.name.includes(ap.ancillaryItem.name.toUpperCase()))
          if (ap?.ancillaryItem?.name.toLowerCase().includes('shuttle')) {
            fact = facts.find(item => item.code === 'SHTL')
            paxSSRs.push(fact.icon)
          }
          else if (fact) {
            paxSSRs.push(fact.icon)
          }
        }
      }
      // NOTE // if passenger has infants, add the SSR icon and add the infant as a passenger
      // NOTE // format and add infants to passengers for rendering (infants don't add toward the passenger total)
      if (pax.passengerJourneyDetail.infants && Array.isArray(pax.passengerJourneyDetail.infants)) {
        let paxInfants = pax.passengerJourneyDetail.infants
        // NOTE // adding infants as basic passengers
        for (let j = 0; j < paxInfants.length; j++) {
          const paxInfant = paxInfants[j];
          // NOTE // infants don't have a title, but do have a gender, so we use gender to get the title
          let title
          let gender = paxInfant.profile.gender.toUpperCase()
          if (gender == 'FEMALE') {
            title = 'Mrs '
          }
          else if(gender == 'MALE') {
            title = 'Mr '
          }
          else {
            title = ''
          }

          let infant = {
            name: (title + paxInfant.profile.firstName + ' ' + paxInfant.profile.lastName) || '',
            rloc: pax.reservation.locator || '',
            dob: paxInfant.profile.birthDate || '',
            ssrs: [< ChildCare/>],
            type: 'infant'
          }
          rows.push(infant)
        }
        paxSSRs.push(<ChildFriendly />)
      }
      paxSSRs = _.uniq(paxSSRs)
      rows.push(createData(type, name, rloc, phone, dob, bagWeight, paxWeight, emailHist, finalDest, resStatus, _.uniq(paxSSRs), travelStatus, key, jKey, paxAuthority, pjd, timestamp,isInterline))
    }
  }

  // NOTE // sort the pax by rloc alphabetically
  rows.sort((pax1, pax2) => {
    if (pax1.lastName > pax2.lastName) { return 1 }
    if (pax1.lastName < pax2.lastName) { return -1 }
    return 0
  })

  return rows
}

export const PaxList = (props) => {

  let key = props.rowKey
  const dispatch = useDispatch();
  const tailItem = useSelector(state => state.entities.departures.paxInfo.find(t => t.key == key))
  const reservationInfo = useSelector(state => state.entities.departures.reservationInfo)
  const fredAccessToken = useSelector(state => state.auth.fredAccessToken)
  const emailHistory = useSelector(state => state.entities.departures.emailHistory)
  const [editBagWeight, setEditBagWeight] = React.useState(false)
  const [bagPassengerIndex, setBagPassenger] = React.useState(0)
  
  const loadPassengerAndReservation = async (rloc, fredAccessToken) => {
    // Load Pax Info via Redux action
    // Fetch reservation info
    const resData = await getResInfo(rloc, fredAccessToken);
    if (resData) {
      dispatch(reservationInfoReceived({ reservationInfo: resData }));
    }
  };

const handleReservationInfo = async () => {
  if (!tailItem?.passengers?.length) return;

  await Promise.all(
    tailItem.passengers.map((item) =>
      loadPassengerAndReservation(item.reservation.locator, fredAccessToken)
    )
  );

};

  useEffect(() => {
    // dispatch(loadPaxInfo(key)) 
    if(tailItem){
      handleReservationInfo()
    }
  }, [tailItem]);

  // NOTE // determines whether to display or edit bag weight. Takes in a bool and a passenger index
  const handleBagWeightsModal = (bool, index) => {
    // NOTE // check for index then set passenger info
    if (index !== undefined) {
      setBagPassenger(index)
    }
    // NOTE // open/close modal
    setEditBagWeight(bool)
  }

  // let passengers = tailItem && tailItem.passengers ? tailItem.passengers.map((passenger) => <li>{passenger.profile.lastName}</li>) : 'No Passengers'
  let rows = configureRows(tailItem, emailHistory,reservationInfo)
  // NOTE // checks passengers in or out
  const handleCheckIn = (key, jkey, timestamp, paxAuthority, {target}) => {
    // TODO // They are testing features related to this right now. Probably will need to implement it later
    // if (paxAuthority && paxAuthority.toLowerCase() == 'inhibited') {
    //   alert("The passengers authority-clearance is 'inhibited', and cannot be checked in")
    // }
    // else {
      const output = {
        travelStatus: {
          notCheckedIn: !target.checked,
          checkedIn: target.checked,
        },
        timestamp: timestamp
      }
      dispatch(updatePax(tailItem, key, jkey, output))
  };
  
  const getBagType = (bag) => {
    let bagTypes = bag.baggageType
    if (bagTypes.regular) {
      return "checked"
    }
    else if (bagTypes.carry) {
      return "carry-on"
    }
    else if (bagTypes.valet) {
      return "valet"
    }
    else {
      return ' '
    }
  }

  const getBags = (bagArr) => {
    let formattedBags = []
    for (let i = 0; i < bagArr.length; i++) {
      const bag = bagArr[i];
      let bagStr = `${bag?.weight?.amount} - ${getBagType(bag)} \n`
      let newBag = {key: bag.key, bagStr: bagStr}
      formattedBags.push(newBag)
    }

    let uniqueBags = _.uniqBy(formattedBags, "key").map(bag => bag.bagStr)
    return uniqueBags
  }

  // NOTE // formats the bag totals for each departure
  const formatTotals = (passengers, type) => {
    // NOTE // creating an object to store the info
    let total = { count: 0, weight: 0 }

    // NOTE // loop over passengers
    for (let i = 0; i < passengers.length; i++) {
      const pax = passengers[i];
      if (type == 'pax') {
        total.count += 1
        total.weight += pax.passengerJourneyDetail.weight.amount
      }
      // NOTE // loop over the passengers bags (if they have any)
      else if (pax.passengerJourneyDetail.bags && type !== 'pax') {
        for (let j = 0; j < pax.passengerJourneyDetail.bags.length; j++) {
          const bag = pax.passengerJourneyDetail.bags[j];
          let bagType = getBagType(bag)
          let bagWeight = bag.weight.amount
          // NOTE // add the number and weight to the correct type (carry-on, checked, total, or overweight)
          if (type == bagType || type == 'total') {
            total.count += 1
            total.weight += bagWeight
          }
          else if (type == 'overweight' && bagWeight >= 50) {
            total.count += 1
            total.weight += bagWeight
          }
        }
      }
    }

    return total
  }

  const ResStatusDisplay = (props) => {
    console.log("Props",props);
    let resStatus = props.resStatus

    if (resStatus == 'CONF') {
      return <TableCell align="center" style={{width: '5%', color: 'green'}}>{resStatus}</TableCell>
    }
    else if (resStatus == 'STBY') {
      return <TableCell align="center" style={{width: '5%', color: 'red'}}>{resStatus}</TableCell>
    }
    else {
      return <TableCell align="center" style={{width: '5%', color: 'red'}}>{resStatus}</TableCell>
    }
  }

  const EmailHistDisplay = (props) => {
    const emailHist = props.emailHist

    const getEmailColor = (emailStatus) => {
      if (emailStatus === true) {
        return '#00b900'
      }
      else if (emailStatus === false) {
        return '#ff0000'
      }
      else {
        return '#9f9c9c'
      }
    }

    const itinColor = getEmailColor(emailHist)
    // NOTE // they currently do not want a display for whether a 24hr email has been sent
    // const post24Color = getEmailColor(emailHist.post24)

    return (
      <div>
        <div style={{backgroundColor: itinColor, color: 'white'}}>itin</div>
        {/* <div style={{backgroundColor: post24Color, color: 'white'}}>24hr</div> */}
      </div>
    )
  }

  const TravelStatusDisplay = (props) => {
    let row = props.row
    let tStatus = row.travelStatus
    let checked = tStatus == 'checked in' ? true : false

    if(tStatus == 'checked in' || tStatus == 'not checked in') {
      return (
        <TableCell>
          <Checkbox align="center" className="no-fastclick" checked={checked} onChange={(e) => handleCheckIn(row.key, row.jKey, row.timestamp, row.paxAuthority, e)} inputProps={{ 'aria-label': 'primary checkbox' }}/>
        </TableCell>
      )
    }
    else if (tStatus == 'no show') {
      return (
      <TableCell align="center" style={{width: '5%', color: 'red'}}>No Show</TableCell>
      )
    }
    else {
      return (
        <TableCell align="center" style={{width: '5%', color: 'green'}}>Boarded</TableCell>
      )
    }
  }

  const classes = useStyles()

  return (
    <>
      {rows && rows.length > 0 ? (
             <TableContainer>
             <Modal
               open={editBagWeight}
               onClose={() => {handleBagWeightsModal(false)}}
               aria-labelledby="simple-modal-title"
               aria-describedby="simple-modal-description"
             >
               <BagModal paxInfo={bagPassengerIndex} rows={rows} dep={tailItem} closeModal={handleBagWeightsModal} />
             </Modal>
             <Table className={classes.table} size="small" aria-label="a dense table">
               <StyledTableHead>
                 <TableRow>
                   <TableCell style={{width: '5%'}} padding="none">Checked In</TableCell>
                   <TableCell align="center">Name</TableCell>
                   <TableCell align="center">RLOC</TableCell>
                   <TableCell align="center">Email Status</TableCell>
                   <TableCell align="center">Phone Number</TableCell>
                   <TableCell align="center">DoB</TableCell>
                   <TableCell align="center">Bags</TableCell>
                   <TableCell align="center">Pax Weight</TableCell>
                   <TableCell align="center">Final Destination</TableCell>
                   <TableCell align="center">Res. Status</TableCell>
                   <TableCell align="center">SSRs</TableCell>
                 </TableRow>
               </StyledTableHead>
               <TableBody>
                 {rows.map((row, index) => (
                   <TableRow key={row.name}>
                     <TravelStatusDisplay row={row} />
                     <TableCell align="center" style={{width: '20%'}}>{row.name+"  "}{row.isInterline ?<FlightTakeoff/>:""}</TableCell>
                     <TableCell align="center">{row.rloc}</TableCell>
                     <TableCell align="center">
                       <EmailHistDisplay emailHist={row.emailHist} />
                     </TableCell>
                     <TableCell align="center">{row.phoneNumber}</TableCell>
                     <TableCell align="center">{row.dob}</TableCell>
                     {
                       row.bagWeight ?
                       <TableCell align="center" size="small" style={{width: '18%', maxHeight: '20%'}}>
                         <Button variant="outlined" style={{boxShadow: '1px 1px 1px black'}} onClick={() => {handleBagWeightsModal(true, index)}}>
                           <Table>
                           {getBags(row.bagWeight).slice(0, 3).map((bag, index) => {
                             return (
                               <TableRow style={{fontSize: 'smaller'}}>{bag}{index == 2 && row.bagWeight.length > 3 ? '...' : ''}</TableRow>
                             )
                           })}
                           </Table>
                         </Button>
                       </TableCell> :
                       <TableCell align="center">
                         <Button style={{fontSize: 'smaller', boxShadow: '1px 1px 1px black'}} disabled={row.type && row.type == 'infant'} variant="outlined" onClick={() => {handleBagWeightsModal(true, index)}}>none</Button>
                       </TableCell>
                     }
                     <TableCell align="center">{row.paxWeight}</TableCell>
                     <TableCell align="center">{row.finalDest}</TableCell>
                     <ResStatusDisplay resStatus={row.resStatus} />
                     <TableCell align="center">{row.ssrs}</TableCell>
                     <TableCell align="center">
                     {row.paxAuthority === "Cleared" || row.paxAuthority === "Known" ? (<LockIcon style={{ color: 'green' }} />) : (<LockOpenIcon style={{ color: 'red' }} />)}
                     </TableCell>
                   </TableRow>
                 ))}
               </TableBody>
             </Table>
             {
               tailItem && tailItem.passengers ?
               <Grid container item xs={12} justify="center" style={{backgroundColor: '#c0c9ff'}}>
                 <Grid item xs={2} style={{paddingTop: '5px'}}>
                   <b>checked</b>: {Math.round(formatTotals(tailItem.passengers, 'checked').weight)} lbs
                 </Grid>
                 <Grid item xs={2} style={{paddingTop: '5px'}}>
                   <b>carry-on</b>: {Math.round(formatTotals(tailItem.passengers, 'carry-on').weight)} lbs
                 </Grid>
                 <Grid item xs={2} style={{paddingTop: '5px'}}>
                   <b>bag total</b>: {Math.round(formatTotals(tailItem.passengers, 'total').weight)} lbs
                 </Grid>
                 <Grid item xs={2} style={{paddingTop: '5px'}}>
                   {/* TODO overweight bags */}
                   <b>overweight</b>: {Math.round(formatTotals(tailItem.passengers, 'overweight').count)} bags
                 </Grid>
                 <Grid item xs={2} style={{paddingTop: '5px'}}>
                   <b>pax total</b>: {Math.round(formatTotals(tailItem.passengers, 'pax').weight)} lbs
                 </Grid>
     
               </Grid> : 
               <div></div>
             }
           </TableContainer>
      ) : tailItem ? (
        <div>No Passengers</div>
      ) : (
        <div></div>
      )}
    </>
  );
//   if (rows && rows.length > 0) {
//     return (
//       <TableContainer>
//         <Modal
//           open={editBagWeight}
//           onClose={() => {handleBagWeightsModal(false)}}
//           aria-labelledby="simple-modal-title"
//           aria-describedby="simple-modal-description"
//         >
//           <BagModal paxInfo={bagPassengerIndex} rows={rows} dep={tailItem} closeModal={handleBagWeightsModal} />
//         </Modal>
//         <Table className={classes.table} size="small" aria-label="a dense table">
//           <StyledTableHead>
//             <TableRow>
//               <TableCell style={{width: '5%'}} padding="none">Checked In</TableCell>
//               <TableCell align="center">Name</TableCell>
//               <TableCell align="center">RLOC</TableCell>
//               <TableCell align="center">Email Status</TableCell>
//               <TableCell align="center">Phone Number</TableCell>
//               <TableCell align="center">DoB</TableCell>
//               <TableCell align="center">Bags</TableCell>
//               <TableCell align="center">Pax Weight</TableCell>
//               <TableCell align="center">Final Destination</TableCell>
//               <TableCell align="center">Res. Status</TableCell>
//               <TableCell align="center">SSRs</TableCell>
//             </TableRow>
//           </StyledTableHead>
//           <TableBody>
//             {rows.map((row, index) => (
//               <TableRow key={row.name}>
//                 <TravelStatusDisplay row={row} />
//                 <TableCell align="center" style={{width: '20%'}}>{row.name}</TableCell>
//                 <TableCell align="center">{row.rloc}</TableCell>
//                 <TableCell align="center">
//                   <EmailHistDisplay emailHist={row.emailHist} />
//                 </TableCell>
//                 <TableCell align="center">{row.phoneNumber}</TableCell>
//                 <TableCell align="center">{row.dob}</TableCell>
//                 {
//                   row.bagWeight ?
//                   <TableCell align="center" size="small" style={{width: '18%', maxHeight: '20%'}}>
//                     <Button variant="outlined" style={{boxShadow: '1px 1px 1px black'}} onClick={() => {handleBagWeightsModal(true, index)}}>
//                       <Table>
//                       {getBags(row.bagWeight).slice(0, 3).map((bag, index) => {
//                         return (
//                           <TableRow style={{fontSize: 'smaller'}}>{bag}{index == 2 && row.bagWeight.length > 3 ? '...' : ''}</TableRow>
//                         )
//                       })}
//                       </Table>
//                     </Button>
//                   </TableCell> :
//                   <TableCell align="center">
//                     <Button style={{fontSize: 'smaller', boxShadow: '1px 1px 1px black'}} disabled={row.type && row.type == 'infant'} variant="outlined" onClick={() => {handleBagWeightsModal(true, index)}}>none</Button>
//                   </TableCell>
//                 }
//                 <TableCell align="center">{row.paxWeight}</TableCell>
//                 <TableCell align="center">{row.finalDest}</TableCell>
//                 <ResStatusDisplay resStatus={row.resStatus} />
//                 <TableCell align="center">{row.ssrs}</TableCell>
//                 <TableCell align="center">
//                 {row.paxAuthority === "Cleared" || row.paxAuthority === "Known" ? (<LockIcon style={{ color: 'green' }} />) : (<LockOpenIcon style={{ color: 'red' }} />)}
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//         {
//           tailItem && tailItem.passengers ?
//           <Grid container item xs={12} justify="center" style={{backgroundColor: '#c0c9ff'}}>
//             <Grid item xs={2} style={{paddingTop: '5px'}}>
//               <b>checked</b>: {Math.round(formatTotals(tailItem.passengers, 'checked').weight)} lbs
//             </Grid>
//             <Grid item xs={2} style={{paddingTop: '5px'}}>
//               <b>carry-on</b>: {Math.round(formatTotals(tailItem.passengers, 'carry-on').weight)} lbs
//             </Grid>
//             <Grid item xs={2} style={{paddingTop: '5px'}}>
//               <b>bag total</b>: {Math.round(formatTotals(tailItem.passengers, 'total').weight)} lbs
//             </Grid>
//             <Grid item xs={2} style={{paddingTop: '5px'}}>
//               {/* TODO overweight bags */}
//               <b>overweight</b>: {Math.round(formatTotals(tailItem.passengers, 'overweight').count)} bags
//             </Grid>
//             <Grid item xs={2} style={{paddingTop: '5px'}}>
//               <b>pax total</b>: {Math.round(formatTotals(tailItem.passengers, 'pax').weight)} lbs
//             </Grid>

//           </Grid> : 
//           <div></div>
//         }
//       </TableContainer>
//     )
//   } else if (tailItem) {
//     return (
//       <div>No Passengers</div>
//     ) 
//   } else {
//     return <div></div>
//   }
 };